import * as Yup from 'yup'

export const initialValues = {
  name: '',
  cif: '',
  companyRegistrationNumber: '',
  phone: '',
  email: '',
  address: '',
  city: {
    id: '',
    name: ''
  },
  county: {
    id: '',
    name: ''
  },
  isTaxPayer: false,
  delegate: {
    firstName: '',
    lastName: '',
    transportType: '',
    transportNumber: '',
    identityCardSeries: '',
    identityCardNumber: '',
    identityCardIssuingDate: null
  }
}

const delegateObject = Yup.object().shape({
  firstName: Yup.string().required('Prenumele delegatului este obligatoriu.'),
  lastName: Yup.string().required('Numele delegatului este obligatoriu.'),
  transportType: Yup.string().required('Tipul de transport al delegatului este obligatoriu.'),
  transportNumber: Yup.string().required('Numarul de transport al delegatului este obligatoriu.'),
  identityCardSeries: Yup.string().required('Seria CI a delegatului este obligatorie.'),
  identityCardNumber: Yup.string().required('Numarul CI a delegatului este obligatoriu.'),
  identityCardIssuingDate: Yup.date().required(
    'Data de eliberare a CI al delegatului este obligatorie.'
  )
})

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Numele este obligatoriu.'),
  cif: Yup.string().required('CIF este obligatoriu.'),
  companyRegistrationNumber: Yup.string().required(
    'Numarul din Registrul Comertului este obligatoriu.'
  ),
  phone: Yup.string()
    .required('Numarul de telefon este obligatoriu.')
    .min(10, 'Trebuie sa aiba exact 10 cifre')
    .max(10, 'Trebuie sa aiba exact 10 cifre'),
  email: Yup.string().email('Trebuie sa fie o adresa de email valida.'),
  address: Yup.string().required('Adresa este obligatorie.'),
  county: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required()
  }),
  city: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required()
  }),
  isTaxPayer: Yup.boolean(),
  delegate: delegateObject
})

export const getCIF = (cif: string) => cif.replace('RO', '').replace('ro', '')
